import { render, staticRenderFns } from "./TgpContent.vue?vue&type=template&id=e2dad852"
import script from "./TgpContent.vue?vue&type=script&lang=js"
export * from "./TgpContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports